import React from 'react';


const Footer = () => {
    return (
        <div className="bg-secondary text-white fw-bold">

            <p><small>Copyright Rejuyan Hossain Shawon 2021.</small></p>
            <h5>Contact Us </h5>
            <p>Email: rejuyanhossainshawon@gmail.com</p>

        </div>
    );
};

export default Footer;